import Vue from "vue";
import Vuex from "vuex";
import { Constants } from "@/common/global.ts";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        /**
         * If the user has clicked yet
         *
         * @type {Boolean}
         */
        clicked: <boolean> false,

        /**
         * If we have preloaded assets already
         *
         * @type {Boolean}
         */
        hasLoaded: <boolean> false,

        /**
         * If we have muted the app
         *
         * @type {Boolean}
         */
        muted: <boolean> true,

        /**
         * Reference to the page we're currently on
         *
         * @type {IBasePage}
         */
        page: <IBasePage> <unknown> null,

        /**
         * If we need to redirect anywhere after preloading
         *
         * @type {String}
         */
        redirectUrl: <string> "",
    },

    getters: {
        clickedState: (state) => {
            return state.clicked ? "state-clicked" : "";
        },
        isPhone: (state) => {
            return window.innerWidth <= Constants.PHONE_WIDTH;
        },
        isTablet: (state) => {
            return window.innerWidth <= Constants.TABLET_WIDTH;
        },
        mutedState: (state) => {
            return state.muted ? "state-off" : "state-on";
        },
        playerState: (state) => {
            return true;
        },
    },

    mutations: {
        setClicked(state) {
            state.clicked = true;
        },
    },
});
